import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import Utils from 'src/app/utils';

import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-monitor-access-controls',
  templateUrl: './monitor-access-controls.component.html',
  styleUrls: ['./monitor-access-controls.component.scss']
})
export class MonitorAccessControlsComponent implements OnInit {

  @Input() monitor:any;

  accessFormGroup = new FormGroup({
    worker_access: new FormControl('none',[]),
    worker_index: new FormControl(false,[]),
    worker_view: new FormControl(false,[]),
    worker_create: new FormControl(false,[]),
    worker_update: new FormControl(false,[]),
    worker_delete: new FormControl(false,[]),
    monitor_access: new FormControl('none',[]),
    monitor_index: new FormControl(false,[]),
    monitor_view: new FormControl(false,[]),
    monitor_create: new FormControl(false,[]),
    monitor_update: new FormControl(false,[]),
    monitor_delete: new FormControl(false,[]),
    group_access: new FormControl('none',[]),
    group_index: new FormControl(false,[]),
    group_view: new FormControl(false,[]),
    group_create: new FormControl(false,[]),
    group_update: new FormControl(false,[]),
    group_delete: new FormControl(false,[]),
    group_ids: new FormControl([],[]),
    broadcast_access: new FormControl('none',[]),
    broadcast_index: new FormControl(false,[]),
    broadcast_view: new FormControl(false,[]),
    broadcast_create: new FormControl(false,[]),
    broadcast_update: new FormControl(false,[]),
    broadcast_delete: new FormControl(false,[])
  })

  has_access = false;

  access_levels_worker:any = ['none','all','monitored','groups'];
  access_levels:any = ['none','all','groups'];
  access_levels_broadcast:any = ['none','all'];

  submitted = false;

  get f(): { [key: string]: AbstractControl } {
    return this.accessFormGroup.controls;
  }



  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    //this.getMonitor();
    this.setForm();

    console.log(this.accessFormGroup);

  }

  ngAfterViewInit()	: void {
    Utils.setupPopover();
  }

  getMonitor(){

    this.okService.get("monitors/"+this.monitor.id,[])
    .subscribe((data) => {

      this.monitor = data.body;

      console.log(this.monitor);

      this.setForm();

    });
  }

  setForm(){

    if(this.monitor.access != null){
      // Access JSON saved via the API/backend default template can lack keys the
      // form expects (e.g. workers.index / workers.update) — setValue() throws
      // NG01002 on undefined values, which silently hid the whole form.
      this.accessFormGroup.setValue({
        worker_access: this.monitor.access.workers?.access ?? 'none',
        worker_index: this.monitor.access.workers?.index ?? false,
        worker_view: this.monitor.access.workers?.view ?? false,
        worker_create: this.monitor.access.workers?.create ?? false,
        worker_update: this.monitor.access.workers?.update ?? false,
        worker_delete: this.monitor.access.workers?.delete ?? false,
        monitor_access: this.monitor.access.monitors?.access ?? 'none',
        monitor_index: this.monitor.access.monitors?.index ?? false,
        monitor_view: this.monitor.access.monitors?.view ?? false,
        monitor_create: this.monitor.access.monitors?.create ?? false,
        monitor_update: this.monitor.access.monitors?.update ?? false,
        monitor_delete: this.monitor.access.monitors?.delete ?? false,
        group_access: this.monitor.access.groups?.access ?? 'none',
        group_index: this.monitor.access.groups?.index ?? false,
        group_view: this.monitor.access.groups?.view ?? false,
        group_create: this.monitor.access.groups?.create ?? false,
        group_update: this.monitor.access.groups?.update ?? false,
        group_delete: this.monitor.access.groups?.delete ?? false,
        group_ids: this.monitor.access.groups?.ids ?? [],
        broadcast_access: this.monitor.access.broadcasts?.access ?? 'none',
        broadcast_index: this.monitor.access.broadcasts?.index ?? false,
        broadcast_view: this.monitor.access.broadcasts?.view ?? false,
        broadcast_create: this.monitor.access.broadcasts?.create ?? false,
        broadcast_update: this.monitor.access.broadcasts?.update ?? false,
        broadcast_delete: this.monitor.access.broadcasts?.delete ?? false
      });

      this.has_access = true;
    }

  }

  submitAccessControls(){

    this.submitted = true;

    console.log('accesscontrols()');

    if(this.accessFormGroup.valid){
        let values:any = {};
        let access:any = {
            "workers": {
                "index": this.accessFormGroup.value.worker_index,
                "view": this.accessFormGroup.value.worker_view,
                "update": this.accessFormGroup.value.worker_update,
                "delete": this.accessFormGroup.value.worker_delete,
                "create": this.accessFormGroup.value.worker_create,
                "access": this.accessFormGroup.value.worker_access
            },
            "monitors": {
                "index": this.accessFormGroup.value.monitor_index,
                "view": this.accessFormGroup.value.monitor_view,
                "update": this.accessFormGroup.value.monitor_update,
                "delete": this.accessFormGroup.value.monitor_delete,
                "create": this.accessFormGroup.value.monitor_create,
                "access": this.accessFormGroup.value.monitor_access
            },
            "groups": {
                "index": this.accessFormGroup.value.group_index,
                "view": this.accessFormGroup.value.group_view,
                "update": this.accessFormGroup.value.group_update,
                "delete": this.accessFormGroup.value.group_delete,
                "create": this.accessFormGroup.value.group_create,
                "access": this.accessFormGroup.value.group_access,
                "ids": this.accessFormGroup.value.group_ids
            },
            "broadcasts": {
                "index": this.accessFormGroup.value.broadcast_index,
                "view": this.accessFormGroup.value.broadcast_view,
                "update": this.accessFormGroup.value.broadcast_update,
                "delete": this.accessFormGroup.value.broadcast_delete,
                "create": this.accessFormGroup.value.broadcast_create,
                "access": this.accessFormGroup.value.broadcast_access
            }
        };

        values.access = access;

        console.log('values',values);
        console.log('monitor',this.monitor.id);

        this.okService.put("monitors/access/"+this.monitor.id,values)
        .subscribe({
          next: (data) => {

            this.monitor = data.body;

            console.log("monitor",this.monitor);

            this.setForm();

            if(this.okService.session.id == this.monitor.id){
              this.okService.refreshUser();
            }

            this.okService.setAlert(this.transloco.translate("The monitor has been updated"),"success");
          },
          error: (e) => {

            //console.log("error",e);

            if(Array.isArray(e)){
              let self = this;
              // Use of _.forEach() method
              _.forEach(e, function(error:any) {
                //console.log(error);
                self.accessFormGroup.get(error.field)?.setErrors({ invalid: error.message });
              });
            }else{
              this.okService.setAlert(e,"warning")
            }

          },
          complete: () => {
            //console.info('complete');
          }
      });

    }

    return false;

  }

  removeMonitorAccess(){
    if(confirm(this.transloco.translate("Are you sure you want to remove custom monitor access?"))) {

      this.okService.delete("monitors/access/"+this.monitor.id)
      .subscribe((data) => {

        this.has_access = false;

        this.monitor = data.body;

        console.log("monitor",this.monitor);

        if(this.okService.session.id == this.monitor.id){
          this.okService.refreshUser();
        }


      });
    }

  }

  createMonitorAccess(){
    

  this.accessFormGroup = new FormGroup({
    worker_access: new FormControl('none',[]),
    worker_index: new FormControl(false,[]),
    worker_view: new FormControl(false,[]),
    worker_create: new FormControl(false,[]),
    worker_update: new FormControl(false,[]),
    worker_delete: new FormControl(false,[]),
    monitor_access: new FormControl('none',[]),
    monitor_index: new FormControl(false,[]),
    monitor_view: new FormControl(false,[]),
    monitor_create: new FormControl(false,[]),
    monitor_update: new FormControl(false,[]),
    monitor_delete: new FormControl(false,[]),
    group_access: new FormControl('none',[]),
    group_index: new FormControl(false,[]),
    group_view: new FormControl(false,[]),
    group_create: new FormControl(false,[]),
    group_update: new FormControl(false,[]),
    group_delete: new FormControl(false,[]),
    group_ids: new FormControl([],[]),
    broadcast_access: new FormControl('none',[]),
    broadcast_index: new FormControl(false,[]),
    broadcast_view: new FormControl(false,[]),
    broadcast_create: new FormControl(false,[]),
    broadcast_update: new FormControl(false,[]),
    broadcast_delete: new FormControl(false,[])
  })

  this.has_access = true;

  }

}
